export const LETS_TALK_PW = "LETS_TALK_PW"

export const password = "nechk2021"